import Vue from "vue";

export const mutations = {
  SET_JOB_APPLICANTS: (state, payload) => Vue.set(state, "jobApplicants", payload),
  SET_JOB_APPLICANT: (state, payload) => Vue.set(state, "jobApplicant", payload),
}
